import USFlag from 'Shared/icons/flags/us.svg';
import AUFlag from 'Shared/icons/flags/au.svg';
import CAFlag from 'Shared/icons/flags/ca.svg';
import DEFlag from 'Shared/icons/flags/de.svg';
import FRFlag from 'Shared/icons/flags/fr.svg';
import UKFlag from 'Shared/icons/flags/uk.svg';
import EUFlag from 'Shared/icons/flags/eu.svg';
import { CSSProperties } from 'react';

const StoreFlag = ({
   storeCode,
   style = undefined,
   id = null,
}: {
   storeCode: string;
   style?: CSSProperties;
   id?: string;
}) => {
   const svgProps = {
      style,
      id,
      'data-country': storeCode,
   };

   switch (storeCode.toUpperCase()) {
      case 'AU':
         return <AUFlag {...svgProps} />;
      case 'CA':
         return <CAFlag {...svgProps} />;
      case 'DE':
         return <DEFlag {...svgProps} />;
      case 'FR':
         return <FRFlag {...svgProps} />;
      case 'UK':
         return <UKFlag {...svgProps} />;
      case 'EU':
         return <EUFlag {...svgProps} />;
      case 'US':
      default:
         return <USFlag {...svgProps} />;
   }
};

export default StoreFlag;
